import {
	NOW_SKIP_RENDER_UNTIL_PRESENT_ATTR,
	NOW_ID_ATTRIBUTE,
	COMPONENT_ID_ATTRIBUTE,
	RESOLVED_PROPS_ATTRIBUTE
} from '@servicenow/ui-internal';

const xlinkNS = 'http://www.w3.org/1999/xlink';
const xmlNS = 'http://www.w3.org/XML/1998/namespace';
const colonChar = 58;
const xChar = 120;

const ATTRIBUTES_TO_PERSIST = [
	NOW_SKIP_RENDER_UNTIL_PRESENT_ATTR,
	NOW_ID_ATTRIBUTE,
	COMPONENT_ID_ATTRIBUTE,
	RESOLVED_PROPS_ATTRIBUTE
];

// This is a modified version of the snabbdom attributes module, which never removes
// NOW_SKIP_RENDER_UNTIL_PRESENT_ATTR attribute during the patch.
function updateAttrs(oldVnode, vnode) {
	let {
		data: {attrs: oldAttrs}
	} = oldVnode;
	let {
		data: {attrs},
		// eslint-disable-next-line prefer-const
		elm
	} = vnode;

	if (!oldAttrs && !attrs) return;

	if (oldAttrs === attrs) return;

	oldAttrs = oldAttrs || {};
	attrs = attrs || {};

	for (const key in attrs) {
		const cur = attrs[key];
		const old = oldAttrs[key];
		if (old !== cur) {
			if (cur === true) {
				elm.setAttribute(key, '');
			} else if (cur === false) {
				elm.removeAttribute(key);
			} else {
				if (key.charCodeAt(0) !== xChar) {
					elm.setAttribute(key, cur);
				} else if (key.charCodeAt(3) === colonChar) {
					// Assume xml namespace
					elm.setAttributeNS(xmlNS, key, cur);
				} else if (key.charCodeAt(5) === colonChar) {
					// Assume xlink namespace
					elm.setAttributeNS(xlinkNS, key, cur);
				} else {
					elm.setAttribute(key, cur);
				}
			}
		}
	}

	for (const key in oldAttrs) {
		/**
		 * Avoid removing NOW_SKIP_RENDER_UNTIL_PRESENT_ATTR during vdom patch/hydration,
		 * because it could be removed before it is consumed by the component. For example:
		 * <component-a>
		 *  #shadow-root
		 *  <component-b now-skip-render-until-present="foo,bar">
		 *  </component-b>
		 * </component-a>
		 * If we don't persist this attribute, when component-a is hydrated, it will be removed
		 * before component-b consumes it.
		 *
		 * Avoid removing now-id and component-id during vdom patch/hydration.
		 * Take the above example again, when we hydrate component-a, the component-b already has
		 * component-id and now-id set on it by component-b's setComponentId(). So the initial
		 * component-b's vnode in component-a's vdom tree will have these attributes. But the
		 * component-a's vdom tree generated by the seismic view function doesn't have these attributes,
		 * causing the trash of those two attributes during the patch process.
		 */
		if (ATTRIBUTES_TO_PERSIST.includes(key)) continue;
		if (!(key in attrs)) {
			elm.removeAttribute(key);
		}
	}
}
export default {create: updateAttrs, update: updateAttrs};
